import { render, staticRenderFns } from "./makeCollectModal.vue?vue&type=template&id=534e1cff"
import script from "./makeCollectModal.vue?vue&type=script&lang=js"
export * from "./makeCollectModal.vue?vue&type=script&lang=js"
import style0 from "./makeCollectModal.vue?vue&type=style&index=0&id=534e1cff&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports